import React, { Fragment } from "react";

window.downloadRedux = () => {
	let cache = [];
	const excludeKeys = ["baseMaps", "mapRef", "baseMap"];
	const reduxString = JSON.stringify(
		window.redux.getState(),
		function (key, value) {
			if (excludeKeys.indexOf(key) > -1) {
				return;
			}
			if (typeof value === "object" && value !== null) {
				if (cache.indexOf(value) !== -1) {
					// Circular reference found, discard key
					return;
				}
				// Store value in our collection
				cache.push(value);
			} else if (typeof value === "function") {
				return;
			}
			return value;
		},
		2
	);
	cache = null; // Enable garbage collection

	// Create a Blob from the JSON string
	const blob = new Blob([reduxString], { type: "application/json" });

	// Create a download link
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = "redux.json";

	// Append the link to the body
	document.body.appendChild(a);

	// Click the link to initiate download
	a.click();

	// Remove the link from the body
	document.body.removeChild(a);

	// Revoke the Blob URL
	URL.revokeObjectURL(url);
};

const SupportService = () => {
	return <Fragment />;
};

export default SupportService;
